export default __webpack_public_path__ + "static/media/w3schools.47b27d63.png";